export default __webpack_public_path__ + "static/media/CHARGE.53089c19.png";